import React from 'react';
import pluralize from 'pluralize';
import { Link } from '../../../../components/Link';
import { CamelizedTrainingMethod } from '../../../../types/app/training-guide';
import { Box, BoxProps } from '../../../../wag-react/next-components/box';
import { Typography } from '../../../../wag-react/components/Typography';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { theme } from '../../../../wag-react/themes/base-theme';
export type TrainingMethodNavBlockProps = {
  methods: CamelizedTrainingMethod[];
} & BoxProps;
export const TrainingMethodNavBlock = ({
  methods,
  ...rest
}: TrainingMethodNavBlockProps) => <Box height={['143px', 'auto']} {...rest} data-sentry-element="Box" data-sentry-component="TrainingMethodNavBlock" data-sentry-source-file="index.tsx">
    <Typography display={['block', 'none']} fontFamily="muliBold" fontSize="12px" px="16px" mt={0} mb="4px" style={{
    textTransform: 'uppercase'
  }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      Jump to section
    </Typography>
    <Flex flexDirection={['column', 'row']} width={1} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      {methods.map(({
      htmlId,
      name,
      totalVotes
    }) => <Link display="flex" flex={1} href={`#${htmlId}`} key={name}>
          <Flex bg={theme.colors.tuftsBlue} flexDirection={['row', 'column']} px="16px" py="12px" width={1}>
            {/* Mobile Only */}
            <Typography variant="body2" color="white" display={['inline', 'none']} flex={3} fontFamily="muliBold" overflow="hidden" style={{
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }} textAlign="left">
              {`The ${name} Method`}
            </Typography>

            {/* Tablet & Desktop Only */}
            <Typography variant="body2" color="white" display={['none', 'inline']} fontFamily="muliBold" textAlign="center">
              {`The ${name} Method`}
            </Typography>

            <Typography variant="body2" color={theme.colors.buttermilk} flex={1} fontFamily="muliBold" textAlign={['right', 'center']}>
              {`${totalVotes} ${pluralize('Vote', totalVotes)}`}
            </Typography>
          </Flex>
        </Link>)}
    </Flex>
  </Box>;